import * as React from 'react';
import { FC } from 'react';

import { makeUclComponent } from '@fhs-legacy/universal-components';
import { ISanityTextNode } from '@rbi-ctg/menu';
import { useFlag } from 'utils/launchdarkly';

import { StyledText } from './loyalty-text-widget.styled';

export interface ITextWidgetProps {
  text: ISanityTextNode;
}

const LoyaltyTextWidget: FC<React.PropsWithChildren<ITextWidgetProps>> = ({
  text,
}: ITextWidgetProps) => {
  const enableMyCodeNewUI = useFlag('enable-my-code-new-ui');

  return <StyledText newUI={enableMyCodeNewUI}>{text.locale}</StyledText>;
};

export default makeUclComponent(LoyaltyTextWidget);
